import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { httpDownload } from "Utils/httpDownload";
import { getDocumentInfo } from "Utils/utilityFunctions";
import { setGlobalErrorStatus } from "Components/StatusHandling";
import { ERROR_MESSAGES } from 'Utils/constants';
import { Card } from "react-bootstrap";
import { getFileTypeColor } from "Utils/icons";
import { getDocURL } from "Utils/fileDownloadUtil";
import { Link } from "react-router-dom";

const DocumentCard = ({ groupId, errorHandle }) => {

  const dispatch = useDispatch();
  const loginInfo = useSelector(state => state.loginInfo);

  const [isLoading, setIsLoading] = useState(true);
  const [statusCode, setStatusCode] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [docBean, setDocBean] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);


  const getDocInfo = (groupId, errorHandle) => {
    setIsLoading(true);

    if (groupId != null && groupId != "") {
      getDocumentInfo(groupId, errorHandle).then((res) => {
        //console.log("getDocumentInfo", res);
        setStatusCode(res.status);
        if (res.status != 1) {
          if (res.globalErrorMessageList != null && res.globalErrorMessageList.length > 0) {
            setErrorMessage(res.globalErrorMessageList[0]);
          }
        } else {
          var d = res.data;
          setDocBean(d.documentTagInfo);
        }

        setIsLoading(false);
        return res;
      }).catch((error) => {
        //console.log("Error caught while loading data: " + error);

        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
        setIsLoading(false);
      });
    }
    else {
      setStatusCode(-1);
      setErrorMessage("Missing Document Group ID!");
    }

    setIsLoading(false);
  }

  useEffect(() => {
    getDocInfo(groupId, errorHandle);
  }, []);

//   const getDocumentDownloadCall = async () => {

//     var url = '/api/dlms/downloadDocument';

//     return httpDownload.post(url, { "groupId": groupId }, {
//       responseType: 'blob',
//       headers: {
//         "Authorization": "Bearer " + loginInfo.token
//         //"Referrer-Policy": "strict-origin-when-cross-origin"
//       }
//     });
//   }

//   const handleFileDownload = async () => {

//     setIsDownloading(true);
//     const res = await getDocumentDownloadCall(groupId);

//     if (res) {
//       //console.log("handleFileDownload", res);
//       // get filename from the res content-disposition
//       const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
//       //console.log("handleFileDownload", filename)
//       let url = window.URL.createObjectURL(res.data);
//       let a = document.createElement('a');
//       a.href = url;
//       a.download = filename;
//       document.body.appendChild(a); // append the element to the dom
//       a.click();
//       a.remove(); // afterwards, remove the element  
//     } else {
//       setGlobalErrorStatus({
//         dispatch: dispatch,
//         popupData: {
//           visible: true,
//           title: ERROR_MESSAGES.GENERAL_ERROR.title,
//           msg: ERROR_MESSAGES.GENERAL_ERROR.message,
//           showContactHelp: true
//         },
//         redirect: {
//           redirect: false,
//           redirectFirst: false,
//           path: "",
//           data: {}
//         }
//       })
//     }
//     setTimeout(() => {
//       //console.log("after file download");
//       setIsDownloading(false);
//     }, 1000);
//   }

//   const handleKeyDown = (e) => {
//     // Key "Enter" to direct
//     if (e.keyCode === 13) {
//       //console.log("handle key down file download");
//       handleFileDownload();
//     }
//   }

  //calculate file size in KB 
  const getFileSizeKB = (value) => {
    if (value <= 0)
      return "0 KB";

    var size = value / 1024;

    var decimalFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0, style: 'decimal' }).format(
      size
    );

    return decimalFormat + " KB";
  }

  //get file ext class: documents.scss
  /*const getExtClass = (ext) => {
    switch (ext) {
      case "pdf":
        return "red-ext";
      case "zip":
        return "red-ext";
      case "xml":
        return "green-ext";
      case "xlsx":
        return "green-ext";
    }
  }*/

  return (
    <>
      {isDownloading ?
        <>
          <Card className="document-card">
            <Card.Body>
              <Card.Title className="card-title mb-0"><a>{docBean?.docDisplayName}</a></Card.Title>
              <Card.Text>
                <div className="mb-3"><span className="ext-disabled">.{docBean?.docExt.toUpperCase()}</span></div>
                <div>{getFileSizeKB(docBean?.docSize)}</div>
              </Card.Text>
            </Card.Body>
          </Card>
        </> :
        <>
          <Card 
            //tabIndex={0} 
            className="document-card" 
            //onClick={() => handleFileDownload()} 
            //onKeyDown={(e) => handleKeyDown(e)} 
            to={getDocURL(groupId)} 
            as={Link} 
            target="_blank" 
            download={docBean?.docDisplayName+"."+docBean?.docExt}
        >
            <Card.Body>
              <Card.Title className="card-title mb-0">{docBean?.docDisplayName}</Card.Title>
              <Card.Text>
                <div className="mb-3"><span className={getFileTypeColor(docBean?.docExt)}>.{docBean?.docExt.toUpperCase()}</span></div>
                <div>{getFileSizeKB(docBean?.docSize)}</div>
              </Card.Text>
            </Card.Body>
          </Card>
        </>}
    </>
  )
}

export default DocumentCard;